var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMissionLaunchinline = function SvgMissionLaunchinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Launch"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.25 46.584C29.25 48.75 26 52 26 52s-3.25-3.25-3.25-5.416a3.25 3.25 0 1 1 6.5 0Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.083 46.583c0 1.084-1.083 2.167-1.083 2.167s-1.083-1.083-1.083-2.167a1.084 1.084 0 0 1 2.166 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.5 11.916h-13v24.917h13V11.917Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.584 2.859a2.158 2.158 0 0 0-3.168 0C22.492 4.926 19.5 8.614 19.5 11.554v.362h13v-.362c0-2.94-2.992-6.628-4.916-8.695Z",
    fill: "#092140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26 27.083a3.842 3.842 0 1 0 0-7.683 3.842 3.842 0 0 0 0 7.683Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26 25.9a2.659 2.659 0 1 0 0-5.317 2.659 2.659 0 0 0 0 5.318Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "m32.5 24.916 5.717 6.67a3.25 3.25 0 0 1 .782 2.115L39 40.083l-6.5-3.25V24.917Z",
    fill: "#092140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "m19.5 36.833-6.5 3.25.001-6.382c0-.775.277-1.525.782-2.114l5.717-6.67v11.916Z",
    fill: "#092140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.333 40.084h-8.666a2.166 2.166 0 0 1-2.167-2.167v-1.084h13v1.084c0 1.197-.97 2.166-2.167 2.166Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.558 44.417H24.44a2.166 2.166 0 0 1-2.102-1.641l-.672-2.693h8.666l-.672 2.693a2.168 2.168 0 0 1-2.103 1.64Z",
    fill: "#092140"
  }))));
};
export default SvgMissionLaunchinline;